import React from 'react';
import PropTypes from 'prop-types';
import Tag from './Tag';

/**
 * Container component for rendering tags
 */
const TagsContainer = ({ tags, useTags, placeholderInvalid, onRemoveTag }) => {
  const showLoader = (index) => index < 10;

  if (!tags || tags.length === 0) {
    return null;
  }

  if (useTags) {
    return (
      <div className="tags-container">
        {tags.map((tag, index) => (
          <Tag
            key={index}
            tag={tag}
            index={index}
            placeholderInvalid={placeholderInvalid}
            showLoader={showLoader(index)}
            onRemove={onRemoveTag}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="simple-text">
      {tags.map((tag, index) => (
        <span key={index}>
          {tag.display || tag.text}
          {tag.invalid && <span className="invalid-message"> ({placeholderInvalid || 'not tracked'})</span>}
          {index !== tags.length - 1 ? ', ' : ''}
        </span>
      ))}
    </div>
  );
};

TagsContainer.propTypes = {
  tags: PropTypes.array.isRequired,
  useTags: PropTypes.bool,
  placeholderInvalid: PropTypes.string,
  onRemoveTag: PropTypes.func.isRequired,
};

TagsContainer.defaultProps = {
  useTags: true,
};

export default TagsContainer;
